<template>
  <div class="page-form">
    <h3 class="title">批导明细</h3>
    <affix>
      <div class="tools">
        <form-button type="default" icon="form-advance" @click="$emit('close')">返回</form-button>
        <form-button
          v-if="conditions.batch_status === 'E001'"
          type="default"
         
          @click="changeStatus('SAVE')"
        >保存</form-button>
        <form-button
          v-if="conditions.batch_status === 'E001' || conditions.batch_status === 'E002'"
          type="default"
          icon="form-advance"
          @click="changeStatus('CANCEL')"
        >取消</form-button>
      </div>
    </affix>

    <div class="form-container">
      <el-form inline class="form" size="mini" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="批次号">
              <el-input
                v-model="conditions.batch_number"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="导入类型">
              <el-input
                v-model="conditions.batch_type_text"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附件名称">
              <el-input v-model="conditions.file_name" disabled placeholder="请输入" type="text" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="批导人">
              <el-input v-model="conditions.batch_name" disabled placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="批导日期">
              <el-input v-model="conditions.mdate" disabled placeholder="请输入" />
              <!-- <el-date-picker v-model="conditions.mdate" disabled type="date" value-format="yyyy-MM-dd" /> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="批导处理状态">
              <el-input v-model="conditions.batch_status_text" disabled placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="批导明细" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getSaleCenterUpdateListDetail,
  apiSaleCenterImportBatchAction
} from '@/api/sap/system-settings'

export default {
  props: {
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      conditions: {
        batch_number: '',
        batch_type_text: '',
        file_name: '',
        batch_name: '',
        datum: '',
        batch_status_text: ''
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { field: 'batch_status_text', title: '处理状态' },
          { field: 'message', title: '消息' },
          { field: 'objpar_id', title: '销售订单号' },
          { field: 'sal_center_name', title: '新营销单元描述' },
          { field: 'sal_center', title: '新营销单元编码' }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.getDetail()
  },
  methods: {
    async changeStatus(mode) {
      const params = {
        HEAD: this.conditions,
        USER_BP: this.role.USER_BP,
        MODE: mode,
        ITEM: this.gridOptions.data
      }
      const res = await apiSaleCenterImportBatchAction(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        Object.assign(this.conditions, res.head)
        this.gridOptions.data = res.item
      } else {
        this.$message.warning(res.message)
      }
    },
    async getDetail() {
      const res = await getSaleCenterUpdateListDetail({ BATCH_NUMBER: this.rowData.batch_number })
      const { head, item } = res.data
      Object.assign(this.conditions, head)
      this.gridOptions.data = item
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/system-manage/importDetail.vue